<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("BUTTONS.view_notification_details") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- Start:: Loading State -->
      <div v-if="loading" class="loading_wrapper">
        <div class="spinner"></div>
        <p class="loading_text">{{ $t("TABLES.loadingData") || "جاري التحميل..." }}</p>
      </div>
      <!-- End:: Loading State -->

      <!-- Start:: Form Content -->
      <form v-else @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Receiver Type Input -->
          <!-- <base-select-input
            col="6"
            :optionsList="receiverTypes"
            :placeholder="$t('PLACEHOLDERS.receiverType')"
            v-model="data.receiverType"
            disabled
          /> -->
          <!-- End:: Receiver Type Input -->

          <!-- Start:: service_providers Type Input -->
          <!-- <base-select-input
            v-if="data.providers && data.receiverType.value === 'provider'"
            col="6"
            :optionsList="data.providers"
            :placeholder="$t('PLACEHOLDERS.service_providers_plural')"
            v-model="data.provider"
            disabled
            multiple
          /> -->
          <!-- End:: Drivers Type Input -->

          <div class="col-12">
            <div class="row">
              <!-- Start:: Title Ar Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleAr')"
                v-model.trim="data.titleAr"
                disabled
              />
              <!-- End:: Title Ar Input -->

              <!-- Start:: Title En Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.titleEn')"
                v-model.trim="data.titleEn"
                disabled
              />
              <!-- End:: Title En Input -->

              <!-- Start:: Content Ar Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentAr')"
                v-model.trim="data.contentAr"
                disabled
              />
              <!-- End:: Content Ar Input -->

              <!-- Start:: Content En Input -->
              <base-input
                col="6"
                rows="7"
                type="textarea"
                :placeholder="$t('PLACEHOLDERS.contentEn')"
                v-model.trim="data.contentEn"
                disabled
              />
              <!-- End:: Content En Input -->
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.send_date')"
                v-model.trim="data.date"
                disabled
              />

              <!-- Start:: Receiver Type Input -->
              <base-input
                col="6"
                type="text"
                :placeholder="$t('PLACEHOLDERS.receiverType')"
                v-model="data.receiverType.name"
                required
                disabled
              />
              <!-- End:: Receiver Type Input -->

              <!-- Start:: Recipients List -->
              <div class="col-12" v-if="data.client && data.client.length > 0">
                <h5 class="mb-3">{{ $t("PLACEHOLDERS.recipients_list") }}</h5>
                <div
                  class="recipients-container"
                  style="
                    max-height: 300px;
                    overflow-y: auto;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    padding: 15px;
                  "
                >
                  <div
                    v-for="(recipient, index) in data.client"
                    :key="recipient.id"
                    class="recipient-item d-flex align-items-center mb-2 p-2"
                    style="background-color: #f8f9fa; border-radius: 4px"
                  >
                    <v-avatar size="40" class="mr-3">
                      <img
                        v-if="recipient.avatar"
                        :src="recipient.avatar"
                        :alt="recipient.name"
                      />
                      <v-icon v-else>mdi-account</v-icon>
                    </v-avatar>
                    <div class="flex-grow-1">
                      <div class="font-weight-bold text-dark">
                        {{ recipient.name }}
                      </div>
                      <div class="text-muted small">{{ recipient.mobile }}</div>
                      <div class="text-muted small" v-if="recipient.email">
                        {{ recipient.email }}
                      </div>
                    </div>
                    <v-chip
                      small
                      :color="index < 5 ? 'primary' : 'secondary'"
                      text-color="white"
                    >
                      #{{ index + 1 }}
                    </v-chip>
                  </div>
                </div>
              </div>
              <!-- End:: Recipients List -->

              <!-- End:: Clients Type Input -->
              <!-- End:: Clients Type Input -->
              <!-- End:: Clients Type Input -->
            </div>
          </div>
        </div>
      </form>
      <!-- End:: Form Content -->
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateNotification",

  
  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allClientsData: "ApiGetsModule/allClientsData",
      allDriversData: "ApiGetsModule/allDriversData",
    }),
    // End:: Vuex Getters
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      loading: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        receiverType: {
          id: null,
          name: null,
          value: null,
        

},
        clients: [],
        providers: [],
        client: [],
        provider: [],
        titleAr: null,
        titleEn: null,
        contentAr: null,
        contentEn: null,
        date: null,
      },

      // End:: Data Collection To Send
    };
  },
  methods: {
    // End:: Vuex Actions
    async getNotificationData() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `notification/show/${this.$route.params.id}`,
        });

        const notification = res.data.data.notification;

        this.data.titleAr = notification.data.title.ar;
        this.data.titleEn = notification.data.title.en;
        this.data.contentAr = notification.data.body.ar;
        this.data.contentEn = notification.data.body.en;
        this.data.date = notification.created_at;

        // تعيين نوع المستلم من recipient_type المترجم
        const recipientType = notification._recipient_type || notification.recipient_type || notification.data.to_type || 'all';
        this.data.receiverType = {
          id: null,
          name: recipientType,
          value: notification.data.to_type || 'all',
        };

        // تعيين قائمة المستلمين
        this.data.client = notification.notifiable || [];
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
        this.$message.error(error.response?.data?.message || 'حدث خطأ أثناء جلب بيانات الإشعار');
      } finally {
        this.loading = false;
      }
    },
    async getClients() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `users?page=0&limit=0&is_active=1`,
        });

        this.data.clients = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    this.getNotificationData();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.loading_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;

  .spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top-color: var(--main_theme_clr, #3eb6d4);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
  }

  .loading_text {
    font-size: 16px;
    color: var(--theme_text_clr, #333);
    margin-top: 10px;
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
